<div class="form-search">
  <mat-form-field [floatLabel]="'always'">
    <mat-spinner [diameter]="22" *ngIf="searching; else searchIcon"
                 class="dropdown-icon spinner-gray"></mat-spinner>
    <ng-template #searchIcon>
      <mat-icon matPrefix class="dropdown-icon">search
      </mat-icon>
    </ng-template>

    <button *ngIf="control?.value"
            (click)="clearSearch($event)"
            class="dropdown-close"
            mat-button
            mat-icon-button
            aria-label="Clear">
      <mat-icon class="dropdown-close-icon">close</mat-icon>
    </button>

    <mat-label></mat-label>
    <input class="dropdown-input"
           type="text"
           [placeholder]="placeholder"
           aria-label="Number"
           matInput
           autocomplete="off"
           [formControl]="control"
           (focus)="onFocus($event)"
           (keydown.enter)="$event.preventDefault()">
  </mat-form-field>
</div>
